import { render, staticRenderFns } from "./WarehousesTab.vue?vue&type=template&id=45c291d4"
import script from "./WarehousesTab.vue?vue&type=script&lang=js"
export * from "./WarehousesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports